export default __webpack_public_path__ + "static/media/Flashlight.6563cb05.png";